import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./Description.module.scss";
import { Grid } from "semantic-ui-react";
import {
  PatternData,
  PatternDifficulty,
  ProfileData,
} from "../../../../types/siteTypes";
import AboutDesigner from "../../../Profiles/AboutDesigner";
import isEmpty from "../../../../validation/is-empty";

type Props = { pattern: PatternData; profile?: ProfileData };

const normalizeDifficulty = (value: unknown): PatternDifficulty => {
  const normalized = typeof value === "string" ? value.trim().toLowerCase() : "";
  if (normalized === "easy" || normalized === "hard" || normalized === "medium") {
    return normalized;
  }
  return "medium";
};

const Description: React.FC<Props> = ({
  pattern: { descriptionLong, clients, categories, fabrics, difficulty, _id },
  profile,
}) => {
  const normalizedPatternDifficulty = normalizeDifficulty(difficulty);

  const infoPaneContent = (element: string[], name: string, titleId: string) =>
    !isEmpty(element) && (
      <div className={styles.category}>
        <h4 className={styles.categoryTitle}>
          <FormattedMessage id={titleId} />
        </h4>
        <div className={styles.categoryContent}>
          {element.map((item: string, key: number) => {
            return (
              <Fragment key={`${name}-${_id}-${item}`}>
                {item}
                {element.length !== ++key && ", "}
              </Fragment>
            );
          })}
        </div>
      </div>
    );

  return (
    <article className={styles.self}>
      <Grid columns={2} stackable className={styles.categoriesGrid}>
        <Grid.Row>
          <Grid.Column width={10}>
            {!isEmpty(descriptionLong) && (
              <div className={styles.description}>
                <p>{descriptionLong}</p>
              </div>
            )}
            {infoPaneContent(clients, "clients", "categories.clients.title")}
            {infoPaneContent(categories, "categories", "categories.categories.title")}
            {infoPaneContent(fabrics, "fabrics", "categories.fabrics.title")}
            <div className={styles.category}>
              <h4 className={styles.categoryTitle}>
                <FormattedMessage
                  id="pattern.difficulty.label"
                  defaultMessage="Difficulty level"
                />
              </h4>
              <div className={styles.categoryContent}>
                <FormattedMessage
                  id={`pattern.difficulty.${normalizedPatternDifficulty}`}
                  defaultMessage={normalizedPatternDifficulty}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column width={6}>
            {profile && <AboutDesigner profile={profile} compact />}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </article>
  );
};

export default Description;
